import React from 'react'
import styled from '@emotion/styled'
import Modal from 'react-modal'

const getStyles = ({ fullHeight, width, isDesktop, padding, bottom, mobileBottom, height, customStyles = {} }) => {
  let styles = {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      zIndex: '10000',
      
    },
    content: {
      border: '0',
      borderRadius: '0',
      padding: '48px 0 0',
      top: '60px',
      left: '20px',
      right: '20px',
      overflow: 'auto',
      bottom: bottom ? bottom : 'auto',
      height: height ? height : 'auto',
      // maxHeight: 'calc(100vh - 120px)',
      ...customStyles
    }
  }

  if (!isDesktop && fullHeight) {
    styles.content.padding = '0'
    styles.content.top = '20px'
    styles.content.bottom = mobileBottom ? mobileBottom : '0'
    // styles.content.height = 'max-content'
    // styles.content.maxHeight = 'calc(100vh - 40px)'
  }

  if (isDesktop && width) {
    styles.content.left = '50%'
    styles.content.transform = `translate3d(calc(${width} / 2 * -1), 0, 0)`
    styles.content.maxWidth = width
    styles.content.width = '100%'
  }

  if (padding) {
    styles.content.padding = padding
  }

  return styles
}

const CloseButton = styled.div`
  cursor: pointer;
  padding: 30px;
  position: ${props =>
    !props.isDesktop && props.fullHeight ? 'fixed' : 'absolute'};
  top: ${props => (!props.isDesktop && props.fullHeight ? '20px' : '0')};
  right: ${props => (!props.isDesktop && props.fullHeight ? '20px' : '0')};
  width: 44px;
  height: 44px;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
`

Modal.setAppElement('*')

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const modalStyles = getStyles(props)

  return (
    <Modal
      isOpen={props.isOpen}
      style={modalStyles}
      onRequestClose={props.closeModal}
      closeTimeoutMS={props.closeTimeoutMS}
      portalClassName={props.portalClassName}
    >
      <CloseButton
        tabIndex={0}
        role="button"
        aria-label='Close'
        onKeyPress={e => (e.key === 'Enter' ? props.closeModal() : false)}
        fullHeight={props.fullHeight}
        onClick={props.closeModal}
        isDesktop={props.isDesktop}
      >
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src='/images/booking-header-close.svg' alt='' aria-hidden='true' />
      </CloseButton>
      {props.children}
    </Modal>
  )
}
